const API_URL =
  import.meta.env.MODE === "development"
    ? "http://localhost:8080"
    : import.meta.env.VITE_API_URL;

/**
 * Generates a new interview, or returns null if interview cannot be generated
 * @param {string} email
 * @param {string} description - Job description pasted in by user
 */
async function generateInterview(email, description) {
  try {
    const res = await fetch(`${API_URL}/api/interview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, description }),
    });
    // Could not generate interview
    if (res.status === 500) {
      return null;
    }

    const newInterview = await res.json();
    return newInterview.savedInterview;
  } catch (e) {
    console.log(e);
    return null;
  }
}

/**
 * Get previous interviews of a given user
 * @param {*} email
 */
async function fetchInterviews(email) {
  try {
    const res = await fetch(
      `${API_URL}/api/interviews/${encodeURIComponent(email)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );
    // Could not find user and/or interviews
    if (res.status === 500) {
      return null;
    }

    const interviews = await res.json();
    return interviews;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export { generateInterview, fetchInterviews };
